<template>
  <div
    class="bg-white"
    id="site-admin-submenu">
    <nav class="sub-menu border-b border-secondary w-full justify-between">
      <!-- <router-link
        class="sub-menu-item"
        :to="{ name: 'SiteAdminCourses' }"
        @click.prevent="gotoRoute({ name: 'SiteAdminCourses' })">
        <IconCourseAlt class="w-6 h-6 mr-2" />
        Courses</router-link
      >
      <router-link
        class="sub-menu-item"
        :to="{ name: 'SiteAdminRefreshers' }"
        @click.prevent="gotoRoute({ name: 'SiteAdminRefreshers' })">
        <IconCourseAlt class="w-6 h-6 mr-2" />
        Refreshers</router-link
      > -->
      <div class="flex items-center justify-start flex-nowrap">
      <router-link
        class="sub-menu-item"
        :to="{ name: 'SiteAdminGroups' }"
        @click.prevent.stop="gotoRoute({ name: 'SiteAdminGroups' })">
        <IconOrg class="w-6 h-6 mr-2" />
        {{ $t("Groups") }}</router-link
      >
      <router-link
        class="sub-menu-item"
        :to="{ name: 'SiteAdminUsers' }"
        @click.prevent="gotoRoute({ name: 'SiteAdminUsers' })">
        <IconUsers class="w-6 h-6 mr-2" />
        Users</router-link
      >
      <!-- <router-link
        class="sub-menu-item"
        :to="{ name: 'SiteAdminTrainersIndex' }"
        @click.prevent="gotoRoute({ name: 'SiteAdminTrainersIndex' })">
        <IconTrainer class="w-6 h-6 mr-2" />
        Trainers</router-link
      > -->
      <router-link
        class="sub-menu-item"
        :to="{ name: 'SiteAdminReportsDashboard' }"
        @click.prevent="gotoRoute({ name: 'SiteAdminReportsDashboard' })">
        <IconReport class="w-6 h-6 mr-2" />
        Reports</router-link
      >
      </div>
      <!-- <router-link
        class="sub-menu-item"
        :to="{ name: 'SiteAdminSuperAdmins' }"
        @click.prevent="gotoRoute({ name: 'SiteAdminSuperAdmins' })">
        <IconSuper class="h-6 w-6 mr-2" />
        Super Admins</router-link
      > -->
      <!-- <router-link
        class="sub-menu-item"
        :to="{ name: 'SiteAdminEmailPreviews' }"
        @click.prevent="gotoRoute({ name: 'SiteAdminEmailPreviews' })">
        <IconEmail class="h-6 w-6 mr-2" />
        Email Previews</router-link
      >
      <router-link
        class="sub-menu-item"
        :to="{ name: 'SiteAdminAdminAudits' }"
        @click.prevent="gotoRoute({ name: 'SiteAdminAdminAudits' })">
        <IconLog class="h-6 w-6 mr-2" />
        Admin Audits</router-link
      >
      <router-link
        class="sub-menu-item"
        :to="{ name: 'SiteAdminDocuments' }"
        @click.prevent="gotoRoute({ name: 'SiteAdminDocuments' })">
        <IconQuill class="h-6 w-6 mr-2" />
        Documents</router-link
      >
      <router-link
        class="sub-menu-item"
        :to="{ name: 'SiteAdminVenues' }"
        @click.prevent="gotoRoute({ name: 'SiteAdminVenues' })">
        <IconLocation class="h-6 w-6 mr-2" />
        Venues</router-link
      > -->

        <button
          @click="showMore = !showMore"
          class="flex flex-nowrap gap-2 sub-menu-item float-right">
          More <IconThreeDots class="h-6 w-6" />
        </button>

    </nav>
  </div>
  <teleport to="body">
    <div class="inset-0 fixed z-50 bg-black bg-opacity-50" v-if="showMore" @click="showMore=false">
    <div
      class="absolute top-24 right-20 bg-white p-4 border border-secondary shadow-md z-50"
      >
      <router-link
        class="sub-menu-item"
        :to="{ name: 'SiteAdminCourses' }"
        @click.prevent="gotoRoute({ name: 'SiteAdminCourses' })">
        <IconCourseAlt class="w-6 h-6 mr-2" />
        Courses</router-link
      >
      <router-link
        class="sub-menu-item"
        :to="{ name: 'SiteAdminLinkedAbstractCourses' }"
        @click.prevent="gotoRoute({ name: 'SiteAdminLinkedAbstractCourses' })">
        <IconCourseAlt class="w-6 h-6 mr-2" />
        Organisation Linked Courses</router-link
      >
      <router-link
        class="sub-menu-item"
        :to="{ name: 'SiteAdminRefreshers' }"
        @click.prevent="gotoRoute({ name: 'SiteAdminRefreshers' })">
        <IconCourseAlt class="w-6 h-6 mr-2" />
        Refreshers</router-link
      >
      <router-link
        class="sub-menu-item"
        :to="{ name: 'SiteAdminTrainersIndex' }"
        @click.prevent="gotoRoute({ name: 'SiteAdminTrainersIndex' })">
        <IconTrainer class="w-6 h-6 mr-2" />
        Trainers</router-link
      >
      <router-link
        class="sub-menu-item"
        :to="{ name: 'SiteAdminSuperAdmins' }"
        @click.prevent="gotoRoute({ name: 'SiteAdminSuperAdmins' })">
        <IconSuper class="h-6 w-6 mr-2" />
        Super Admins</router-link
      >
      <router-link
        class="sub-menu-item"
        :to="{ name: 'SiteAdminEmailPreviews' }"
        @click.prevent="gotoRoute({ name: 'SiteAdminEmailPreviews' })">
        <IconEmail class="h-6 w-6 mr-2" />
        Email Previews</router-link
      >
      <router-link
        class="sub-menu-item"
        :to="{ name: 'SiteAdminAdminAudits' }"
        @click.prevent="gotoRoute({ name: 'SiteAdminAdminAudits' })">
        <IconLog class="h-6 w-6 mr-2" />
        Admin Audits</router-link
      >
      <router-link
        class="sub-menu-item"
        :to="{ name: 'SiteAdminDocuments' }"
        @click.prevent="gotoRoute({ name: 'SiteAdminDocuments' })">
        <IconQuill class="h-6 w-6 mr-2" />
        Documents</router-link
      >
      <router-link
        class="sub-menu-item"
        :to="{ name: 'SiteAdminVenues' }"
        @click.prevent="gotoRoute({ name: 'SiteAdminVenues' })">
        <IconLocation class="h-6 w-6 mr-2" />
        Venues</router-link
      >
    </div>
  </div>
  </teleport>
</template>
<script>
export default {
  data() {
    return {
      showMore: false
    };
  },
  methods: {
    gotoRoute(route) {
      this.showMore = false;
      this.$router.push(route);
      this.$store.commit("closeMobileMenu");
    }
  }
};
</script>
<style lang="postcss" scoped>
.sub-menu {
  @apply bg-secondary bg-opacity-25  px-0 md:px-12 text-dark-grey text-sm flex flex-row flex-wrap items-center;
}
.sub-menu-item {
  @apply text-xs xl:text-base py-1 md:py-2 px-4 md:px-8 
    flex flex-row justify-start items-center flex-none w-full md:w-auto;
}
.sub-menu-item:hover {
  @apply bg-secondary bg-opacity-75 text-white transition duration-500;
}
.sub-menu-item.router-link-active {
  @apply bg-secondary text-white transition duration-500;
}
</style>
